import { getContext, setContext } from 'svelte';
export function injectPlugin(nameOrNamedPlugin, maybePlugin) {
    const contextName = 'threlte-plugin-context';
    if (Array.isArray(nameOrNamedPlugin)) {
        const [name, plugin] = nameOrNamedPlugin;
        setContext(contextName, {
            ...getContext(contextName),
            [name]: plugin
        });
    }
    else {
        const name = nameOrNamedPlugin;
        const plugin = maybePlugin;
        if (!plugin)
            return;
        setContext(contextName, {
            ...getContext(contextName),
            [name]: plugin
        });
    }
}
